declare global {
  interface Window {
    __csp_violations: SecurityPolicyViolationEvent[]
  }
}

/**
 * `captureCSPViolations` listens for `securitypolicyviolation`
 * events and stores them in global variable `__csp_violations`.
 */
export const captureCSPViolations = () => {
  window.__csp_violations = window.__csp_violations || []

  document.addEventListener('securitypolicyviolation', (event) => {
    window.__csp_violations.push(event)
  })
}
